import { FC } from "react";
import { IconPropsType } from ".";

export const Subject: FC<IconPropsType> = (props) => {
  return (
    <svg
      width={props.size ?? "23"}
      height={props.size ?? "23"}
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="10.9551"
        y="0.525391"
        width="7.07108"
        height="7.07108"
        rx="2"
        transform="rotate(44.7306 10.9551 0.525391)"
        fill={props.color ?? "#6873F5"}
      />
      <rect
        x="4.98242"
        y="6.55273"
        width="7.07108"
        height="7.07108"
        rx="2"
        transform="rotate(44.7306 4.98242 6.55273)"
        fill={props.color ?? "#6873F5"}
      />
      <rect
        x="16.9824"
        y="6.49609"
        width="7.07108"
        height="7.07108"
        rx="2"
        transform="rotate(44.7306 16.9824 6.49609)"
        fill={props.color ?? "#6873F5"}
      />
      <rect
        x="11.0098"
        y="12.5254"
        width="7.07108"
        height="7.07108"
        rx="2"
        transform="rotate(44.7306 11.0098 12.5254)"
        fill={props.color ?? "#6873F5"}
      />
    </svg>
  );
};
